import globalStyles from "../../../assets/styles/base/globalPage.module.scss";
import primaryComponents from "../../primaryComponents";

const DeletePrompt = ({
  children,
  title = "",
  isSubmiting,
  onClose = () => {},
  onSubmit = () => {},
}) => {
  return (
    <div className="py-3 px-3">
      <h4 className="text-center font-weight-semibold">{title}</h4>
      <div className={globalStyles.cardWithBackground}>{children}</div>

      <div
        className="d-flex justify-content-between mt-4"
        style={{ gap: "20px" }}
      >
        <primaryComponents.Button
          onClick={onClose}
          classNames={"btn btn--outline cover"}
        >
          Cancel
        </primaryComponents.Button>
        <primaryComponents.Button
          onClick={onSubmit}
          classNames={"btn btn--danger cover"}
          isLoading={isSubmiting}
          isDisabled={isSubmiting}
          loadingText="..."
        >
          Continue
        </primaryComponents.Button>
      </div>
    </div>
  );
};
export default DeletePrompt;
